import * as React from 'react'

export const IconArrowLeft = (props: React.SVGAttributes<any>) => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-arrow-left"
      {...props}
    >
      <path d="M19 12L5 12" />
      <path d="M12 19L5 12 12 5" />
    </svg>
  )
}
